// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"business-setup_wrapper__XjENz","container":"business-setup_container__E8W49","content":"business-setup_content__K43Sy","buttons":"business-setup_buttons__JtKRA"};